import { apiFetch } from '../client';
import type { CatalogPermissionsResponse } from '../types/permissions';

export const catalogApi = {
    /** Catálogo del actor; con `tenantId` (solo actor de plataforma), el del tenant indicado. */
    listPermissions: (tenantId?: string) =>
        apiFetch<CatalogPermissionsResponse>(
            tenantId
                ? `/catalog/permissions?${new URLSearchParams({ tenantId }).toString()}`
                : '/catalog/permissions',
        ),
    listCategories: () =>
        apiFetch<{ items: Array<{ key: string; displayName: string }> }>('/catalog/categories'),
};
